import React from "react";
import { Input } from "./input";

// URLs válidas de post/reel de Instagram (FRA-301). Se exporta para que el
// guardado del venue filtre lo inválido antes de escribir.
export const IG_POST_RE = /^https:\/\/(www\.)?instagram\.com\/(p|reel)\/[A-Za-z0-9_-]+\/?/;

export const MAX_IG_POSTS = 3;

// Instagram entrega el "código de incrustación" como un blockquote HTML
// enorme con el permalink adentro (y con ?utm_source=...). De cualquier cosa
// pegada se extrae y canoniza el link del post; si no hay link, se deja tal
// cual para que el error de validación lo muestre.
const IG_EXTRACT_RE = /instagram\.com\/(p|reel)\/([A-Za-z0-9_-]+)/;

export function normalizeIgPost(raw) {
  const value = (raw || "").trim();
  // Solo se normaliza cuando la entrada trae "basura" alrededor del link
  // (HTML del embed, query params, espacios). Una URL limpia tecleada a mano
  // no se toca — si no, la canonización se comería lo tecleado después del
  // primer match parcial.
  if (!/[<?\s]/.test(value)) return value;
  const match = value.match(IG_EXTRACT_RE);
  return match ? `https://www.instagram.com/${match[1]}/${match[2]}/` : value;
}

// Hasta 3 URLs de posts de Instagram. Vive a nivel galería de evento: los
// posts se muestran en el feed de ESE evento en la ficha pública, no sueltos
// al final del venue. El campo es opcional.
export default function InstagramPostsField({
  value = [],
  onChange,
  label = "Posts de Instagram",
  help = null,
}) {
  const rows = Array.from({ length: MAX_IG_POSTS }, (_, i) => value[i] ?? "");

  const setRow = (i, v) => {
    const next = [...rows];
    next[i] = normalizeIgPost(v);
    while (next.length && !next[next.length - 1]) next.pop();
    onChange(next);
  };

  return (
    <div>
      <label className="block mb-1 font-medium">{label}</label>
      <p className="mb-2 text-xs text-zinc-400">
        {help ||
          `Pega hasta ${MAX_IG_POSTS} links de posts o reels — sirve el link directo o el código de incrustación completo que te da Instagram (nosotros extraemos el link).`}
      </p>
      <div className="space-y-2">
        {rows.map((url, i) => {
          const invalid = url !== "" && !IG_POST_RE.test(url);
          return (
            <div key={i}>
              <Input
                value={url}
                onChange={(e) => setRow(i, e.target.value)}
                placeholder={`https://www.instagram.com/p/… (post ${i + 1})`}
                invalid={invalid || undefined}
              />
              {invalid && (
                <p className="mt-1 text-xs text-red-600">
                  Debe ser un link de post o reel de Instagram. Este link no se
                  guardará.
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
